export default __webpack_public_path__ + "static/media/fire.c0879fbb.svg";